"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const hooks_1 = require("hooks");
const useIntroEDS_1 = __importDefault(require("../_hooks/useIntroEDS"));
const eds_store_1 = require("../_store/eds.store");
const gotoURL_1 = require("../_utils/gotoURL");
const DisabledEDS_1 = __importDefault(require("../DisabledEDS"));
const IntroFormEDS_1 = __importDefault(require("./IntroFormEDS"));
const IntroEDS = () => {
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const [getBlackboxData] = (0, hooks_1.useIovation)();
    const { postCreateCreditApp, dataFeatureFlags } = (0, useIntroEDS_1.default)();
    // Store
    const { edsEnabled } = (0, eds_store_1.useEDSStore)();
    // Func - Handle submit callback
    const handleSubmitCallback = async (data) => {
        // Blackbox data
        const blackboxData = getBlackboxData();
        // Post - Create Credit Application
        const resp = await postCreateCreditApp({
            postConsumerApplicationsV2CreditApplicationsCreate: {
                source: 'eds',
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                ...{ specialty: data.specialty ? data.specialty : undefined },
                ...{ locationId: data.locationId ? data.locationId : undefined },
                prerequisiteTermsAccepted: [
                    {
                        termContentId: 1,
                        acceptedOn: new Date().toISOString(),
                    },
                ],
                iovationBlackBox: blackboxData,
                ssn: '',
                dateOfBirth: '',
                annualIncome: 0,
                street1: '',
                city: '',
                state: '',
                zip: '',
                primaryPhone: '',
            },
        });
        if ('error' in resp) {
            if ('error' in resp.error) {
                /* Error Message  - Left blank intentionally in case the application needs further user action */
            }
        }
        else {
            // Push to next page
            pushToNext({
                applicationInfo: resp.data,
                blackboxData: blackboxData,
                formData: data,
            });
        }
    };
    // Func - Push to next page
    const pushToNext = ({ applicationInfo, blackboxData, formData, }) => {
        // Store Data
        eds_store_1.useEDSStore.setState({
            edsInfoForm: {
                ...formData,
            },
            edsApplicant: {
                ...applicationInfo,
            },
            blackboxData: blackboxData,
        });
        (0, gotoURL_1.gotoApplications)(history);
    };
    (0, react_1.useEffect)(() => {
        if (dataFeatureFlags) {
            const FF = dataFeatureFlags.featureFlags;
            if (FF.consumerEds) {
                // Enable EDS
                eds_store_1.useEDSStore.setState({
                    edsEnabled: true,
                });
            }
            if (FF.consumerEds === false) {
                // Disable EDS
                eds_store_1.useEDSStore.setState({
                    edsEnabled: false,
                });
            }
        }
    }, [dataFeatureFlags]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "max-width-800 mar-auto", children: [edsEnabled && (0, jsx_runtime_1.jsx)(IntroFormEDS_1.default, { submitCallback: handleSubmitCallback }), edsEnabled === null && (0, jsx_runtime_1.jsx)(components_1.Spinner, {}), edsEnabled === false && (0, jsx_runtime_1.jsx)(DisabledEDS_1.default, {})] }));
};
exports.default = IntroEDS;
